// extracted by mini-css-extract-plugin
module.exports = {"backToBottom":"BackToBottom_backToBottom__q_A1C","showBottom":"BackToBottom_showBottom__Hsm2f"};